export default function({ state, rootState, commit, dispatch }) {
    commit('startLoadingEvents')

    return dispatch('get', {
        url: '/provider/' + state.id + '/event',
        query: {
            expand: true
        }
    }, {
        root: true
    })
    .then((response) => {
        commit('finishLoadingEvents')
        commit('addPatients', response.patient)
        commit('addProviderEvents', response.event)
        return response
    })
    .catch((error) => {
        commit('finishLoadingEvents')
        console.log(error)
        throw error
    })
}
